import { Link, Image } from "@shopify/hydrogen"
import { HorizontalSeperator } from "@client"
// ----------------------------------------------------------------------

export default function CookingSpices(){
  return(
      <div className="container relative grid grid-cols-1 gap-6 lg:grid-cols-2 md:gap-20">
        <div className="top-[100%] md:top-[90%] center-absolute ">
          <Image src='/emblems/bitters-spices.svg' width={101} height={111} alt=" " role="presentation" />
        </div>
        <div className="flex flex-col justify-between gap-20">
          <div className="flex flex-col items-center mx-auto text-center">
            <h2 className="max-w-sm">Bitters & Ground Spices</h2>
            <div className="py-6 w-[16rem] md:w-[28rem]">
                <HorizontalSeperator />
              </div>
            <p className="max-w-sm text-ornament">
              When a recipe calls for a ground spice like cumin or cinnamon, or a spice blend like garam masala, you can enhance the use of a spice with the additional flavor of bitters. Below are some of our favorite combinations for adding bitters when using specific spices.
            </p>
          </div>
          <Image src='/images/cooking/ground-spice.jpg' width={366} height={455} alt='Three bitters bottles on a pile of spices' className="object-cover w-full max-w-md mx-auto aspect-4/5" />
        </div>
        <div className="grid grid-cols-1 gap-16 md:grid-cols-2 md:gap-10">
          <div className="flex flex-col items-center justify-start gap-1 text-center">
            <h3>Black Pepper</h3>
            <span className="text-ornament"></span>
            <Link to="/shop/products/ginger-allspice" className="label">Ginger Allspice Bitters
            </Link>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 text-center">
            <h3>Chili Powder or Cayenne</h3>
            <span className="text-ornament"></span>
            <Link to="/shop/products/chipotlecacao" className="label">Chipotle Cacao Bitters
            </Link>
            <Link to="/shop/products/disco-inferno-liquid-heat" className="label">Disco Inferno: Liquid Heat
            </Link>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 text-center">
            <h3>Cinnamon</h3>
            <span className="text-ornament"></span>
            <Link to="/shop/products/blackstrap" className="label">Blackstrap Bitters
            </Link>
            <Link to="/shop/products/bolivar" className="label">Bolivar Bitters
            </Link>
            <Link to="/shop/products/cherry-bark-vanilla" className="label">Cherry Bark Bitters
            </Link>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 text-center">
            <h3>Cumin</h3>
            <span className="text-ornament"></span>
            <Link to="/shop/products/orange" className="label">Orange Bitters
            </Link>
            <Link to="/shop/products/chipotlecacao" className="label">Chipotle Cacao Bitters
            </Link>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 text-center">
            <h3>Coriander</h3>
            <span className="text-ornament"></span>
            <Link to="/shop/products/orange" className="label">Orange Bitters
            </Link>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 text-center">
            <h3>Garam Masala</h3>
            <span className="text-ornament"></span>
            <Link to="/shop/products/ginger-allspice" className="label">Ginger Allspice Bitters
            </Link>
            <Link to="/shop/products/orange" className="label">Orange Bitters
            </Link>
            <Link to="/shop/products/blackstrap" className="label">Blackstrap Bitters
            </Link>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 text-center">
            <h3>Jerk Seasoning</h3>
            <span className="text-ornament"></span>
            <Link to="/shop/products/ginger-allspice" className="label">Ginger Allspice Bitters
            </Link>
            <Link to="/shop/products/grapefruit-hibiscus" className="label">Grapefruit Hibiscus Bitters
            </Link>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 text-center">
            <h3>Oregano or Sage</h3>
            <span className="text-ornament"></span>
            <Link to="/shop/products/chipotlecacao" className="label">Chipotle Cacao Bitters
            </Link>
            <Link to="/shop/products/all-day-aromatic-bitters" className="label">All Day Aromatic Bitters
            </Link>
          </div>
          <div className="flex flex-col items-center justify-start gap-1 text-center">
            <h3>Herbs de Provence</h3>
            <span className="text-ornament"></span>
            <Link to="/shop/products/bolivar" className="label">Bolivar Bitters
            </Link>
            <Link to="/shop/products/orange" className="label">Orange Bitters
            </Link>
          </div>


          <div className="flex items-center justify-center col-span-1 md:col-span-2">
            <Link to="/shop/bitters" className="mx-auto btn btn-action">Shop Bitters</Link>
          </div>
        </div>
      </div>
  )
}